import { render, staticRenderFns } from "./RollingNumber.vue?vue&type=template&id=85f75bd6&scoped=true"
import script from "./RollingNumber.vue?vue&type=script&lang=js"
export * from "./RollingNumber.vue?vue&type=script&lang=js"
import style0 from "./RollingNumber.vue?vue&type=style&index=0&id=85f75bd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!D:\\Code\\ui\\comic_ai\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f75bd6",
  null
  
)

export default component.exports